// @flow

import { find, findIndex } from 'lodash';

import { type Plan } from '@zapier/common-utils';

export default (
  plans: Array<Plan>,
  currentPlanId: number,
  isFall2019Pricing: boolean = false
): number => {
  return isFall2019Pricing
    ? findIndex(plans, plan =>
        find(plan.taskLimitVariants, variant =>
          find(variant.intervals, interval => interval.id === currentPlanId)
        )
      )
    : findIndex(plans, plan =>
        find(plan.intervals, interval => interval.id === currentPlanId)
      );
};
